<template>
    <div class="box">
  
      
      <a-row :gutter="24">
        <a-col :md="24">
          <a-card>
            <!-- 查询区域 -->
            <div class="table-page-search-wrapper">
              <a-form layout="inline">
                <a-row :gutter="24">
                  <a-col :md="6">
                    <a-form-item label="商品名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
                      <a-input placeholder="请输入商品名称" v-model="queryParam.name"></a-input>
                    </a-form-item>
                  </a-col>
                  
                  <a-col :md="6">
                    <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
                      <a-col :md="6" :sm="24">
                        <a-button type="primary" @click="searchQuery">查询</a-button>
                        <a-button style="margin-left: 8px" @click="searchReset">重置</a-button>
                      </a-col>
                    </span>
                  </a-col>
                </a-row>
              </a-form>
            </div>
            <!-- 操作按钮区域 -->
            <div class="table-operator"  style="margin-top: 5px">
            </div>
  
            <!-- table区域-begin -->
            <div>
              <a-table
                ref="table"
                size="middle"
                bordered
                rowKey="uuid"
                :columns="columns"
                :dataSource="dataSource"
                :pagination="ipagination"
                @change="handleTableChange">
                <span slot="action" slot-scope="text, record">
                  <a @click="handleScan(record)"> 去扫码</a>
                  <a-divider type="vertical" />
                  <a @click="handlePrint(record)">去打印</a>
                </span>
                <template slot="status" slot-scope="status">
                    <a-tag color="red" v-if="status === 1">待处理</a-tag>
                    <a-tag color="green" v-else-if="status === 2">已完成</a-tag>
                    <a-tag color="blue" v-else >未知</a-tag>
                </template>
              </a-table>
            </div>
          </a-card>
        </a-col>
      </a-row>
      <!-- 新增/编辑区域 -->
      <scan-task ref="handleScanTask"></scan-task>
      <print-task ref="handlePrintTask"></print-task>
      <!-- <add-process ref="addProccessRef" @ok="modalFormOk" @close="modalFormClose"></add-process>
      <begin-dialog ref="BeginDialogRef" @ok="BeginDialogOk"></begin-dialog>
      <bind-rule-list ref="bindRuleList" @update:codeRuleId="onCodeRuleIdUpdate" @ok="bindRuleListOk" @close="handleSubComponentClose"></bind-rule-list>
      <bind-trace-module-list ref="bindTraceModuleList" @ok="bindTraceModuleListOk" @update:traceTemplateId="onTraceTemplateIdUpdate" @close="handleTraceTemplateClose"></bind-trace-module-list>
      <event-trace-list ref="traceListRef" @ok="traceListOk" @close="closeTraceList"></event-trace-list>
      <process-dialog ref="processRef"></process-dialog> -->
    </div>
  </template>
  
  <script>
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import { queryEnableDictItemsByCode } from '@/api/identifierCode/identifierCode'
    import { getFileAccessHttpUrl } from '@/api/manage'
    import ScanTask from './modules/scanTask.vue'
    import PrintTask from './modules/printTask.vue'
    // import ProcessDialog from './modules/processDialog.vue'
    // import AddProcess from './modules/addProcess.vue'
    // import BeginDialog from './modules/beginDialog.vue'
    // import BindRuleList from './modules/bindRuleList.vue'
    // import EventTraceList from './modules/eventTraceList.vue'
    // import BindTraceModuleList from './modules/bindTraceModuleList.vue'
    import { delProcess, getCraftByMaterialId, queryProcessByCraftId, getTraceProdPlanRecordList } from '@/api/api'
    export default {
      name: "list",
      mixins:[JeecgListMixin],
      components: {
        ScanTask,
        PrintTask
        // ProcessDialog,
        // BeginDialog,
        // AddProcess,
        // BindRuleList,
        // BindTraceModuleList,
        // EventTraceList
      },
      data() {
        return {
          current: ['enterpriseRule'], // 顶部导航栏
          bindInfo:{},
          // 查询区域布局
          labelCol: {
            span: 5
          },
          wrapperCol: {
            span: 18,
            offset: 1
          },
  
          // 查询条件
          queryParam: {},
          menuItems: [],
          dropdownStates: {},
          menuVisiable: false,
          dropdownVisible: false, // 控制下拉框的显示状态
          // 表头
          columns: [
            {
              title: '序号',
              dataIndex: '',
              key:'rowIndex',
              width: '50px',
              align:"center",
              customRender:function (t,r,index) {
                return parseInt(index)+1;
              }
            },
            {title: '名称 ', dataIndex: 'name', align:"center",},
            {title: '规格', dataIndex: 'productNo', align:"center",},
            {title: '工艺', dataIndex: 'craftName', align:"center",},
            {title: '工序', dataIndex: 'proceName', align:"center",},
            {
                title: '状态', 
                dataIndex: 'status', 
                align:"center", 
                scopedSlots: { customRender: 'status' },render: (text) => text || "--",
            },
            // {title: '图片 ', dataIndex: 'pic', align:"center",scopedSlots: { customRender: 'customPic' } },
            {
              title: '操作',
              dataIndex: 'action',
              width: '10%',
              align:"center",
              scopedSlots: { customRender: 'action' },
            },
          ],
          ipagination: {
            current: 1,
            pageSize: 10,
            pageSizeOptions: ['10', '20', '30'],
            showTotal: (total, range) => {
                return range[0] + '-' + range[1] + ' 共' + total + '条'
            },
            showQuickJumper: true,
            showSizeChanger: true,
            total: 0
          },
          url: {
            // list: "/process/traceProdPlanRecord/list",
            delete: "/codeRules/fzRule/delete",
            deleteBatch: "/codeRules/fzRule/deleteBatch"
          },
          visibleRuleNode: false, // 规则节点抽屉开关
          uuid: '', // 每一项的uuid
  
          // 下拉框数据
          ruleSystem: [], // 发码机构
          ruleCategory: [], // 参考标准
          ruleLabel: [] // 类别
        }
      },
      computed: {
        
      },
      mounted() {
        this.getTaskList()
      },
      methods: {
        async getTaskList(){
          const params = {
            name: this.queryParam.name,
            currentPage: this.ipagination.current,
            pageSize: this.ipagination.pageSize,
          }
          const res = await getTraceProdPlanRecordList(params)
          if(  res.code == 200 && res.success == true ){
            this.dataSource = res.result.records
            this.ipagination.total = res.result.total
          }
        },
        searchQuery(){
          this.getTaskList()
        },
        getImgUrl (imgName, type) {
          if (imgName && imgName.split(',')) {
            type = type ? type + '/' : ''
            return getFileAccessHttpUrl('systemConfig/static/' + type + imgName.split(',')[0])
          } else {
            return ''
          }
        },
        handleScan(e){
          this.$refs.handleScanTask.show(e)
        },
        handlePrint(e){
          this.$refs.handlePrintTask.show(e)
        },
        // 获取工艺列表
        async getCraftByMaterialId(record){
          this.menuItems = []
          const params = {
            materialId: record.id
          }
          const res = await getCraftByMaterialId(params)
          if(  res.code == 200 && res.success == true ){
            const resData = res.result
            this.menuItems = resData.map(item => ({
              id: item.id,
              craftName: item.craftName,
              craftCode: item.craftCode,
              subItems: []
            }))
          } else {
            this.$message.warning(res.message)
          }
        },
        // 处理菜单项点击事件
        handleMenuItemClick(item) {
          console.log('Selected item:', item)
          // 在这里处理菜单项点击后的逻辑
          // this.dropdownVisible = false // 关闭下拉框
          this.queryProcessByCraftId(item)
        },
        async queryProcessByCraftId(item){
          const params = {
            craftId: item.id,
            materialId: item.materialId
          }
          const res = await queryProcessByCraftId(params)
          if(  res.code == 200 && res.success == true ){
            console.log( res.result,' res.result====================')
            const resData = res.result
            if(resData.length == 0){
               this.$message.warning('该工艺下暂无生产流程，请先添加生产流程')
            } else {
              item.subItems = resData.map(subItem => ({
                codeRuleId: subItem.codeRuleId,
                processId: subItem.processId,
                proceName: subItem.proceName,
                craftId: subItem.craftId,
                seq: subItem.seq,
              }))
            }
            
          } else {
            this.$message.warning(res.message)
          }
        },
        handleProcessClick(subItem, record){
          this.menuItems = []
          // 隐藏弹框
          console.log(record,'record======================')
          this.$refs.BeginDialogRef.open(subItem, record)
          this.dropdownVisible = false
        },
        // 
        modalFormOk(){
          this.loadData()
        },
        modalFormClose(){

        },
        bindRuleListOk(){

        },
        bindTraceModuleListOk(){

        },
        BeginDialogOk(){
          
        },
        handleAdd(){
          this.$refs.addProccessRef.add()
        },
        handleEdit(record){
            this.$refs.addProccessRef.edit(record)
        },
        chooseTemplateOk(){
          this.loadData()
        },
        onCodeRuleIdUpdate(newId){
            this.codeRuleId = newId;
            console.log('新的规则ID:', newId);
        },
        onTraceTemplateIdUpdate(newId){
            this.formTemplateId = newId;
            console.log('新的模版ID:', newId);
        },
        handleSubComponentClose() {
            this.loadData(); // 刷新父组件数据
        },
        handleTraceTemplateClose() {
            this.loadData(); // 刷新父组件数据
        },
        // 规则节点抽屉变化事件
        afterVisibleChange(val) {
          console.log('visible', val)
  
        },
        // 规则节点抽屉关闭 - 点击事件
        onClose() {
          this.visibleRuleNode = false;
        },
        begin(record){
            this.$refs.BeginDialogRef.open(record.codeRuleId)
            
        },
        // 删除
        async handleDelete(id){
          const res = await delProcess(id)
          if( res.code == 200 && res.success == true ){
            this.$message.success('删除成功')
            this.loadData()
          } else {
            this.$message.error('删除失败')
          }
        },
  
      },
      watch: {
        current() {
          this.queryParam.isStandard = this.current[0] === 'enterpriseRule' ? '1' : '0' // 规则查询参数
          this.loadData(1)
        }
      },
      created() {
        // 获取发码机构下拉框
        queryEnableDictItemsByCode({code: 'send_code_org'})
        .then(res => {
          this.ruleSystem = res
        })
        // 获取参考标准下拉框
        queryEnableDictItemsByCode({code: 'Reference_Standards'})
        .then(res => {
          this.ruleCategory = res
        })
        // 获取类别单选框
        queryEnableDictItemsByCode({code: 'rule_code_type'})
        .then(res => {
          this.ruleLabel = res
        })
      }
    }
  </script>
  
  <style scoped>
    .item-img {
      cursor: pointer;
      position: static;
      display: block;
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  </style>